import { useEffect, useState } from "react";
import { connectStepStore } from "@features/StepsContent/components/StepConnect/store/connectStepStore";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Text, Image } from "@mantine/core";
import { emailStepStore } from "@/entities/StepEmail/store/emailStepStore";
import { FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType } from "@/api/gen";
import { appStore } from "@/app/store/appStore";
import { basePath } from "@/app/AppRoutes";

import styles from "./stepSignUpComplete.module.scss";
import { StepNavigationButtons } from "@/entities/StepNavigationButtons/StepNavigationButtons";
import setAppDir = FxApi.File.setAppDir;

export const StepSignUpComplete = () => {
	console.log("Render StepSignUpComplete...");

	const { logout, email } = emailStepStore();
	//
	// useEffect(() => {
	// 	appStore.getState().setLoginFlow(false);
	// }, []);

	const { appCode } = appStore();
	const { profiles, refreshProfiles } = connectStepStore();
	const { t } = useTranslation();
	const [myGamesId, setMyGamesId] = useState<string>();

	function handlePrevButton() {
		logout();
	}

	function handleNextButton() {
		appStore.getState().setLoginFlow(false);
	}

	useEffect(() => {
		refreshProfiles();
	}, [refreshProfiles]);

	const [searchParams] = useSearchParams();
	const forMyGamesId = searchParams.get("for_mygames_id");

	useEffect(() => {
		const myGamesIdSocId = profiles?.SocialIdentifiers.find(
			(el) => el.Type === FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType.MyGamesId
		);

		if (myGamesIdSocId != null) {
			setMyGamesId(myGamesIdSocId.Id);
		}
	}, [profiles]);

	return (
		<div className={styles.modalWrapper}>
			<div className={styles.wrapper}>
				<Image id={`${appCode}_email`} h={100} src={`${basePath}${appCode}/logo-icon.svg`} alt="email" />
				<p className={styles.description}>{t("common.signup_complete", "Signup Complete")}</p>
				{myGamesId === forMyGamesId && <p>{t("common.mygames_attached", "My Games Account is attached")}</p>}
				{myGamesId !== "" && forMyGamesId && myGamesId !== forMyGamesId && (
					<>
						<Text
							size="xl"
							fw={900}
							variant="gradient"
							ta="center"
							gradient={{ from: "red", to: "orange", deg: 90 }}
						>
							{t(
								"common.email_is_attached_to_different_account",
								"{{email}}  is attached to different MyGames account",
								{ email: email?.toUpperCase() || "email" }
							)}
							<br />
							<Text
								size="xl"
								fw={900}
								variant="gradient"
								gradient={{ from: "blue", to: "green", deg: 90 }}
							>
								{" "}
								{t(
									"common.please_login_with_new_email",
									"Please login with different email to attach this MyGames account"
								)}
							</Text>
						</Text>
					</>
				)}
				{!myGamesId && (
					<Text size="xl" fw={900} variant="gradient" gradient={{ from: "red", to: "orange", deg: 90 }}>
						{t("common.mygames_not_attached", "My Games Account is not attached")}
					</Text>
				)}
			</div>
			<StepNavigationButtons
				backText={null}
				backOnClick={handlePrevButton}
				backIsDisabled={false}
				nextText={t("common.Ok", "Ok")}
				nextOnClick={handleNextButton}
				nextIsDisabled={false}
			/>
		</div>
	);
};
